import {IAirport, ICurrency, IPlane, IPlaneCategory} from "../fleetReducer/fleetReducerTypes";
import {CommonState, ItemListState, RemoteActionState} from "../highOrderReducers/commonReducer";
import {
  EmptyLegOrderRouteEntity, OrderEntity,
} from "../../../proto/generated/api_entities_pb";
import {OrderRequestStatusEnum} from "../../../utils/constans/statuses/orderRequestStatuses";
import {EmptyLegOrderRouteStatusEnum} from "../../../utils/constans/statuses/emptyLegOrderRouteStatuses";
import {IUser} from "../userReducer/userReducerTypes";
import {ICompany} from "../companyReducer/companyReducerTypes";
import {IOrderRequestPlane} from "../freighterRequestsReducer/freighterRequestsReducerTypes";


export enum OrderTypeEnum {
  ONE_WAY = 1,
  ROUND_TRIP = 2,
  MULTI_LEG = 3,
  EMPTY_LEG = 4,
}

export enum OrderStatusEnum {
  NOT_ANSWERED = 1,
  ACCEPTED = 2,
  DECLINED = 3,
}

export interface IChartererOrder {
  id: number;
  type: OrderTypeEnum;
  user: IUser;
  company: ICompany;
  createdDate: Date;
  planeCategories: IPlaneCategory[];
  companionsAllowed: boolean;
  comment: string;
  orderRoutes: IChartererOrderRoute[];
  nestedEmptyLegs: IChartererEmptyLegFromOrder[];
  nestedOrderRequests: IChartererOrderRequestFromOrder[];
  isArchived: boolean;
  isFavorite: boolean;
}

export interface IChartererEmptyLegFromOrder {
  emptyLegId: number;
  orderRouteId: number;
  emptyLegOrderRouteId: number;
  freighterUser: IUser;
  freighterCompany: ICompany;
  airportFrom: IAirport;
  airportTo: IAirport;
  plane: IPlane;
  availableFromDate?: Date;
  availableToDate?: Date;
  departureDate?: Date;
  arrivalDate?: Date;
  price: number;
  currency: ICurrency;
  flyHours: number;
  flyMinutes: number;
  flyDistance: number;
  comment: string;
  dateModified?: Date;
  status: EmptyLegOrderRouteStatusEnum;
  isArchived: boolean;
}

export interface IChartererOrderRouteOrderRequest {
  orderRouteOrderRequestId: number;
  flyHours: number;
  flyMinutes: number;
  flyDistance: number;
  arrivalDate: Date;
  technicalStopDuration?: number;
  technicalStopCount?: number;
  orderRoute: IChartererOrderRoute;
}

export interface IChartererOrderRequestFromOrder {
  orderRequestId: number;
  createdAtDate: Date;
  updatedAtDate?: Date;
  freighterUser: IUser;
  freighterCompany: ICompany;
  plane?: IPlane, // @deprecated Используйте planeList
  orderRequestPlaneId?: number; // @deprecated Используйте planeList
  price: number;
  currency: ICurrency;
  orderRouteOrderRequests: IChartererOrderRouteOrderRequest[];
  status: OrderRequestStatusEnum;
  isArchived: boolean;
  planeList?: IOrderRequestPlane[]; // Список всех самолетов в заявке
}

export interface IChartererOrderRoute {
  id: number;
  airportFrom: IAirport;
  airportTo: IAirport;
  departureDate: Date;
  pax: number;
  flyDuration?: number; // Flight duration in minutes for this leg (calculated during order creation)
  flyDistance?: number; // Flight distance in km for this leg (calculated during order creation)
}

export interface IGetChartererOrderListPayload {
  page: number;
  types: OrderTypeEnum[];
  airportFromId?: number;
  airportToId?: number;
  onlyApproved?: boolean;
  showArchived: boolean;
  isFavorite?: boolean;
}

export interface ISetChartererOrderListResultPayload {
  items: OrderEntity[];
  totalCount: number;
}

export interface IChangeEmptyLegOrderRouteWithdrawPayload {
  orderRouteId: number;
  emptyLegId: number;
  emptyLegOrderRouteStatus: EmptyLegOrderRouteStatusEnum;
}

export interface ISetChangeEmptyLegOrderRouteWithdrawResultPayload {
  emptyLegOrderRoute?: EmptyLegOrderRouteEntity;
  errorMessage?: string;
}

export interface IArchiveOrderPayload {
  itemId: number
}

export interface ISetArchiveOrderResultPayload {
  itemId?: number;
  errorMessage?: string;
}

export interface IUpdateOrderFavoritePayload {
  orderId: number;
  isFavorite: boolean;
}

export interface ISetUpdateOrderFavoriteResultPayload {
  success?: boolean;
  orderId?: number;
  isFavorite?: boolean;
  errorMessage?: string;
}

export interface IUpdateOrderRequestPlaneStatusPayload {
  orderId: number;
  orderRequestId: number;
  orderRequestPlaneId: number;
  status: number; // OrderRequestPlaneStatusEnum
}

export interface IGetOrderListCountsPayload {
  types: OrderTypeEnum[];
  airportFromId?: number;
  airportToId?: number;
  onlyApproved?: boolean;
}

export interface ISetOrderListCountsResultPayload {
  active: number;
  archival: number;
  favorites: number;
}

export interface IChartererRequestsInitialState extends CommonState<IChartererOrder>{
  itemsObject: ItemListState<IChartererOrder>;
  changeEmptyLegOrderRouteWithdraw: RemoteActionState;
  delete: RemoteActionState;
  updateOrderFavorite: RemoteActionState;
  orderListCounts: {
    active: number;
    archival: number;
    favorites: number;
    isLoading: boolean;
  };
}